<template>
  <div class="flex" id="billing-information">
    <div class="flex column align-center justify-center aside">
       <img src="@/assets/images/facturacionIcon.svg" class="icon" alt="Error icon" />
      <p class="label">
        DATOS DE FACTURACIÓN
      </p>
    </div>
    <div v-if="!formActive" class="flex column information">
      <div
        v-if="userIsCompanyAdmin || userIsNormalType"
        @click="formActive = true"
        class="edit-link"
      >
        Editar
      </div>
      <PersonalInformationRow
        title="Nombre"
        v-model="billing_name"
      />
      <PersonalInformationRow
        title="Correo"
        v-model="billing_email"
      />
      <PersonalInformationRow
        title="RFC"
        v-model="billing_rfc"
      />
    </div>
    <BillingInformationForm
      @closeForm="closeForm"
      v-if="formActive"
    />
  </div>
</template>

<script>
import PersonalInformationRow from '@/components/Vehicles/PersonalInformationRow'
import BillingInformationForm from '@/components/BillingInformationForm'
import { mapGetters } from 'vuex'

export default {
  name: 'BillingInformation',
  components: {
    PersonalInformationRow,
    BillingInformationForm
  },
  data () {
    return {
      formActive: false
    }
  },
  methods: {
    showForm () {
      this.formActive = true
    },
    closeForm () {
      this.formActive = false
    }
  },
  computed: {
    ...mapGetters([
      'billing_name',
      'billing_email',
      'billing_rfc'
    ]),
    ...mapGetters('user', [
      'userIsCompanyAdmin',
      'userIsNormalType'
    ])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#billing-information {
  border-radius: 2rem;
  width: 38%;
  height: 11rem;
  justify-content: center;
  word-wrap: break-word;
}

.aside {
  border-radius: 2rem 0 0 2rem;
  background-color: $green;
  height: 100%;
  width: 42%;
}

.icon {
  fill: $white;
  width: 3.5rem;
}

.label {
  color: $white;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1.5rem;
  width: 60%;
}

.information {
  background-color: $white;
  border-radius: 0 2rem 2rem 0;
  width: 58%;
  justify-content: center;
  position: relative;
  z-index: 0;
}

.edit-link {
  font-style: italic;
  color: #008AB3;
  align-self: flex-end;
  margin: 0.5rem 1rem;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

@media(max-width: 90rem) {
  #billing-information {
    height: 12rem;
  }

  .icon {
    width: 3.5rem;
  }

  .label {
    font-size: 1rem;
  }
}

@media screen and (max-width: 480px) {
  #billing-information {
    width: 100%;
    margin-bottom: 6%;
  }
  .label {
    width: 100%;
  }
}
</style>
